import CheckingIcon from '@assets/order/status/checking.png';
import ConfirmedIcon from '@assets/order/status/confirmed.png';
import DeniedIcon from '@assets/order/status/denied.png';
import React from 'react';

interface StatusIconProps {
    minHeight?: number,
    height?: number,
    width?: number
}

export const CheckingStatusIcon: React.FC<StatusIconProps> = ({ height, minHeight = 25, width = 45, }) => {
    return (
        <img
            src={CheckingIcon}
            height={height}
            style={{ minHeight: minHeight }}
            width={width} />
    )
}

export const ConfirmedStatusIcon: React.FC<StatusIconProps> = ({ height, minHeight = 25, width = 45, }) => {
    return (
        <img
            src={ConfirmedIcon}
            height={height}
            style={{ minHeight: minHeight }}
            width={width} />
    )
}

export const DeniedStatusIcon: React.FC<StatusIconProps> = ({ height, minHeight = 25, width = 45, }) => {
    return (
        <img
            src={DeniedIcon}
            height={height}
            style={{ minHeight: minHeight }}
            width={width} />
    )
}